import HeaderContainer from "./container";
import Header from "./component";

export default HeaderContainer;



// WEBPACK FOOTER //
// ./client/modules/common/components/Header/index.tsx